import React from 'react'
import { Alert } from '@ztechapps/webui.util'
import { useOrderShippingRates } from '../../hooks/useOrderShippingRates'

export const ShippingRatePanelEmptyResult = () => {
  const [, { error }] = useOrderShippingRates()

  return (
    <Alert type="warning">
      <h4>Carrier have no shipping options available. You can still add a manual shipping rate.</h4>
      <div className={'text-danger'}>{error?.message?.toString()}</div>
    </Alert>
  )
}
